export const SET_EMPLOYEE_INTEGRATIONS_RESULT = 'SetEmployeeIntegrationResult';
export const SET_DEAL_EVENTS_RESULT = 'SetDealEventsResult';
export const SET_UPDATE_EMPLOYEE_INTEGRATION_CREDENTIALS_RESULT =
	'SetUpdateEmployeeCredentialsREsult';
export const SET_TITLE_REQUEST_RESULT = 'SetTitleRequestResult';
export const SET_CREDIT_APPLICATION_INITIAL_INFO_RESULT =
	'SetCreditApplicationInitialInfoResult';
export const SET_STATES_RESULT = 'SetStatesResult';
export const SET_CREDIT_APPLICATION_EXISTS_RESULT =
	'SetCreditApplicationExistsResult';
export const SAVE_CREDIT_APPLICATION_RESULT = 'saveCreditApplicationResult';
export const SET_CREDIT_APPLICATION_INTEGRATIONS_RESULT =
	'setIntegrationsResult';
export const SUBMIT_CREDIT_APPLICATION_RESULT = 'submitCreditApplicationResult';
export const SET_CREDIT_REPORT_INITIAL_INFO_RESULT =
	'setCreditReportInitialInfoResult';
export const SET_CREDIT_REPORT_EXISTS_RESULT = 'SetCreditReportExistsResult';
export const SET_CREDIT_REPORT_INTEGRATIONS_RESULT = 'SetCreditReportIntegrationsResult';
export const SAVE_CREDIT_REPORT_RESULT = 'saveCreditReportResult';
export const SET_RECENT_CREDIT_REPORT_RESULT = 'setRecentCreditReportResult';
export const SUBMIT_CREDIT_REPORT_RESULT = 'submitCreditReportResult';
export const SET_CREDIT_REPORT_HISTORY_RESULT = 'setCreditReportHistoryResult';
export const SET_ATTACHMENT_RESULT = 'setAttachmentResult';